module.exports = __webpack_public_path__ + "static/media/sarajevoShuttle.b3e402e7.png";